import React from "react";
import { motion } from "framer-motion";

const chapters = [
  {
    num: "01",
    title: "Punctuality is a promise",
    body: "We track your flight, watch the traffic, and arrive before you need us. In this city, minutes are currency — we never spend yours.",
  },
  {
    num: "02",
    title: "Discretion is the default",
    body: "Tinted privacy, silent professionals, and journeys that stay between you and the road. What happens in the cabin, stays in the cabin.",
  },
  {
    num: "03",
    title: "The car is only the beginning",
    body: "A chilled bottle of water. The route you prefer. The temperature already set. Luxury is the sum of details you never had to ask for.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] },
  }),
};

export const Manifesto = () => {
  return (
    <section id="manifesto" className="relative py-32 md:py-48 bg-[var(--nl-bg)]" data-testid="manifesto">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="label text-gold mb-20"
        >
          The Namarck Ethos
        </motion.p>

        <div className="space-y-24 md:space-y-40">
          {chapters.map((c, i) => (
            <motion.div
              key={c.num}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
              className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-16 items-start"
            >
              <div className="md:col-span-3">
                <span className="font-serif text-6xl md:text-8xl text-gold/30 leading-none">{c.num}</span>
              </div>
              <div className="md:col-span-9 max-w-3xl">
                <h3 className="font-serif font-light text-4xl md:text-6xl leading-[1.05] tracking-tight mb-6">
                  {c.title}
                </h3>
                <p className="text-white/50 text-lg md:text-xl font-body font-light leading-relaxed">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
